import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ProcessesResponse } from '../models/processesResponse';
import { Observable, of } from 'rxjs';
import { ProcessesQueryString } from '../models/processesQueryString';
import { ProcessDetails } from '../models/process-details.model';

@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  public getProcesses(query: ProcessesQueryString): Observable<ProcessesResponse> {
    const url = `${this.apiUrl}/processes`;
    const params = this.params(query ?? {});

    return this.http.get<ProcessesResponse>(url, { params });
  }

  public getProcessById(processId: string): Observable<ProcessDetails> {
    return this.http.get<ProcessDetails>(`${this.apiUrl}/processes/${processId}`);
  }

  public getProcessStepById(processStepId: string): Observable<any> {
    return this.http.get<ProcessDetails>(`${this.apiUrl}/processes/steps/${processStepId}`);
  }

  private params(query: ProcessesQueryString): HttpParams {
    let params = new HttpParams().set('index', query.index ?? 0).append('size', query.size ?? 10);

    if (query.id !== null && query.id !== undefined) {
      params = params.append('id', query.id.toString());
    }

    if (query.name) {
      params = params.append('name', query.name);
    }

    if (query.status !== null && query.status !== undefined) {
      params = params.append('status', query.status.toString());
    }

    if (query.workflowId !== null && query.workflowId !== undefined) {
      params = params.append('workflowId', query.workflowId.toString());
    }

    if (query.startDate) {
      params = params.append('startDate', query.startDate.toISOString());
    }

    if (query.endDate) {
      params = params.append('endDate', query.endDate.toISOString());
    }

    return params;
  }

  public getProcessesMock(): Observable<ProcessesResponse> {
    return of({
      currentIndex: 0,
      pageSize: 10,
      totalCount: 2632,
      totalPages: 264,
      results: [
        {
          id: 'ebf22763-7e48-459f-b1b8-43fa27a62fe1',
          createdAt: '2024-02-07T17:13:52.931Z',
          updatedAt: '2024-02-07T17:13:53.422Z',
          isActive: true,
          name: 'FindUserById',
          workflowId: 'd16d7cfd-c7a8-4f4e-a0fc-73692cef28b9',
          workflowVersionId: 'a631cc34-a8c4-4004-ae4d-a949aecb621f',
          processOwnerUserId: '3ea179b1-17cd-4dd0-a293-b348582acc9a',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: '211a23f4-76a4-421f-a6f2-88fc58f48858',
          createdAt: '2024-02-06T19:37:19.546Z',
          updatedAt: '2024-02-06T19:37:21.163Z',
          isActive: true,
          name: 'FindStores',
          workflowId: '5025a0f6-573c-4c39-adec-282546b587d1',
          workflowVersionId: '02b06be5-613c-4a97-ac72-5cb1f3f60a1a',
          processOwnerUserId: '1c5402f9-7206-4555-8213-2073a481a003',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: 'a60830b5-c6aa-4771-80a9-6f50db27ebad',
          createdAt: '2024-02-06T18:27:10.427Z',
          updatedAt: '2024-02-06T18:27:13.757Z',
          isActive: true,
          name: 'FindStores',
          workflowId: '5025a0f6-573c-4c39-adec-282546b587d1',
          workflowVersionId: '02b06be5-613c-4a97-ac72-5cb1f3f60a1a',
          processOwnerUserId: '9d49f53f-57cf-4fe1-87dc-d67eaeb4e226',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: '51455671-b552-4357-9e5f-02c9bb8291f9',
          createdAt: '2024-02-06T18:26:05.387Z',
          updatedAt: '2024-02-06T18:26:05.403Z',
          isActive: true,
          name: 'FindStores',
          workflowId: '5025a0f6-573c-4c39-adec-282546b587d1',
          workflowVersionId: '02b06be5-613c-4a97-ac72-5cb1f3f60a1a',
          processOwnerUserId: '5e50465a-84c6-4241-b656-88bd7bd403ab',
          status: 'Processing',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: 'd8879f36-c5ac-495e-81d1-7672258fcef3',
          createdAt: '2024-02-05T14:22:24.967Z',
          updatedAt: '2024-02-05T14:22:27.517Z',
          isActive: true,
          name: 'DisableUsers',
          workflowId: '374c076c-7f6b-4808-9a16-99df6fd0319b',
          workflowVersionId: '6dcbc097-8e09-4905-8279-d81b76797098',
          processOwnerUserId: '20e5ef70-1129-48c9-9668-efb878e078b5',
          status: 'FinishedWithError',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: 'b309d6bb-1d66-4405-9316-585a314e5916',
          createdAt: '2024-02-05T14:22:21.732Z',
          updatedAt: '2024-02-05T14:22:21.965Z',
          isActive: true,
          name: 'FindSectors',
          workflowId: '8afdce15-b28c-4642-ab37-ae2b3e268f67',
          workflowVersionId: 'bbbaeabe-49b6-409e-bf5b-7b3f4d470ebd',
          processOwnerUserId: 'd992fa17-9f7c-4e07-915d-14cada293012',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: '7a1e2285-8ebb-4a88-88a3-2ca482124b71',
          createdAt: '2024-02-05T14:22:20.885Z',
          updatedAt: '2024-02-05T14:22:21.061Z',
          isActive: true,
          name: 'FindSectorById',
          workflowId: '19b39ecb-285e-4508-bba2-1ea5df2bcd6b',
          workflowVersionId: '5dd08934-acca-4c35-80ad-0c449a3289b3',
          processOwnerUserId: 'e99a8d15-517a-4508-aacb-333710fc657c',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: '0dae69f0-78da-41a5-a06c-178f22854191',
          createdAt: '2024-02-05T14:22:19.912Z',
          updatedAt: '2024-02-05T14:22:20.245Z',
          isActive: true,
          name: 'FindSectorById',
          workflowId: '19b39ecb-285e-4508-bba2-1ea5df2bcd6b',
          workflowVersionId: '5dd08934-acca-4c35-80ad-0c449a3289b3',
          processOwnerUserId: '08e731da-3ad6-46cb-b90d-9fd2aee0b972',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: 'aead14fb-557e-4ba3-a1ec-b54a50805f0a',
          createdAt: '2024-02-05T14:22:16.871Z',
          updatedAt: '2024-02-05T14:22:17.791Z',
          isActive: true,
          name: 'DisableSectors',
          workflowId: '5f5457ba-c49e-4b1b-837a-c5c7cb63608a',
          workflowVersionId: '0527f6cb-6815-45e0-a69d-2cf956aad109',
          processOwnerUserId: '5293855e-918f-41f6-b1f2-04aec10b022b',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
        {
          id: '0fd0229a-6841-4aea-9d6c-b3835eb5b147',
          createdAt: '2024-02-05T14:22:11.905Z',
          updatedAt: '2024-02-05T14:22:14.205Z',
          isActive: true,
          name: 'EditSectors',
          workflowId: 'c58b3725-f177-4301-81b0-3cb9158f1828',
          workflowVersionId: 'e7b27119-4170-48df-82ff-cc52c9939d8e',
          processOwnerUserId: '69e11573-3fe8-4ccd-a14d-9706f8f1b53e',
          status: 'Finished',
          system: {
            id: '',
            name: '',
            company: {
              id: '',
              name: '',
            },
          },
        },
      ],
    });
  }
}
